// export const BASE_URL = "http://localhost:5018/atlas-api/";
export const BASE_URL = "https://atlas.passionit.com/atlas-api/";
export const LOGIN = `${BASE_URL}login`;
export const SIGNUP = `${BASE_URL}signup`;
export const VERIFY_OTP_API = `${BASE_URL}verify-otp`;
export const CLIENT_URL = "http://atlas.passionit.com:8983";
// export const CLIENT_URL = "http://localhost:8983";
